<template>
  <proa-modal
    :modal="fileNames.length !== 0"
    :title="$t('common.modals.attachmentFileSizeLimitErrorModal.title')"
    @close="$emit('close')"
  >
    <div class="mb-3">{{ $t('common.modals.attachmentFileSizeLimitErrorModal.message') }}</div>
    <div v-for="fileName in fileNames" :key="fileName" class="mb-1 text-secondary">{{ fileName }}</div>
    <div class="font-weight-w6 mt-3">{{ $t('common.modals.attachmentFileSizeLimitErrorModal.upperLimitMessage') + currentLicensedPlan.maxFileSize + $t('common.mb') }}</div>
  </proa-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AttachmentFileSizeLimitErrorModal',
  computed: {
    ...mapGetters({
      currentLicensedPlan: 'auth/currentLicensedPlan'
    })
  },
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    fileNames: {
      type: Array,
      default: () => []
    }
  }
}
</script>
